import { Component, Input, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

import { } from '@types/googlemaps';
import {FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import {QuestionBase} from '../../models/question-base';
import {QuestionControlService} from '../../services/question-control.service';
import {QuestionService} from '../../services/question.service';
import {Answer} from '../../models/answer';
import {ContentService} from '../../services/content.service';
import {applySourceSpanToExpressionIfNeeded} from '@angular/compiler/src/output/output_ast';
import {Indicator} from '../../models/indicator';
import {ImageViewerComponent, ImageViewerModule} from 'ngx-image-viewer';


declare var jQuery: any;
declare var $: any;



@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css'],
  providers: [QuestionService, QuestionControlService]
})
export class ContentComponent implements OnInit {
  public urlPhone: string = '../../../assets/images/u9966.png';
  public urlMessage: string = '../../../assets/images/u9976.png';
  public urlTv: string = '../../../assets/images/u10026.png';
  public urlFace: string = '../../../assets/images/u9996.png';
  public urlTwit: string = '../../../assets/images/u10006.png';
  public urlInst: string = '../../../assets/images/u10016.png';

  @ViewChild('gmap') gmapElement: any;
  @ViewChild('youtube_link') youtubeElement: any;
  map: google.maps.Map;

  public srcSlider: string = '';
  public srcSliderEnd:string;
  public srcSliderStart: string;
  public disp: string = 'none';
  public backgroundc: string = 'black';
  items: Array<any> = [];
  @Input() data: any;
  public youtube: any;
  public vimeo: string;
  public radioSelected: any;
  public mapProp: any;
  private answers: Answer;

  style;
  hovered;

  public questions: any[];
  public question: QuestionBase<any>[] = [];
  form: FormGroup;
  payLoad = '';

  public CONFIG: any;
  public imageIndex: any;
  public images: any;



  /**@author Lupita Llamas
   * Constructor de la clase
   * Tiene una promesa para tomar los valores del servicio y ponerlo en vista
   * @param {ModalService} modalService
   * @param {DomSanitizer} _sanitizer
   * @param {QuestionControlService} qcs
   * @param {QuestionService} _questionsService
   */
  constructor(private modalService: ModalService,
              private _sanitizer: DomSanitizer,
              private qcs: QuestionControlService,
              private _questionsService: QuestionService,
              private _contentService: ContentService) {
    this.CONFIG = this._contentService.configImageViewer();
    this.images = ['http://localhost:8000/images/1/22.jpg'];
    const promise = new Promise((resolve, reject) => {
      setTimeout(() => {
       // console.log(this.data);
        this.youtube = this.data.card.youtube;
        this.vimeo = this.data.card.vimeo;
        /*this.youtubeElement.src = 'https://www.youtube.com/embed/' + this.data.card.youtube;*/
        $('#youtube_link').attr('src', 'https://www.youtube.com/embed/' + this.data.card.youtube);
        $('#vimeo_link').attr('src', 'https://player.vimeo.com/video/' + this.data.card.vimeo);

        const latlng = new google.maps.LatLng(this.data.card.lat, this.data.card.lng);
        this.mapProp = {
          center: new google.maps.LatLng(this.data.card.lat, this.data.card.lng),
          zoom: 15,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        this.map = new google.maps.Map(this.gmapElement.nativeElement, this.mapProp);
        const marker = new google.maps.Marker({
          position: latlng,
          map: this.map,
          title: 'Got you!'
        });

        this.questions = _questionsService.getQuestions(this.data.questions);
        this.form = this.qcs.toFormGroup(this.questions);

        this.images = [];
        this.data.images.forEach( image => {
          /*console.log(image.url);*/
          this.images.push(image.url);
         /* console.log(this.images);*/
        });
      }, 1500);
    });
  }


  /**@author Lupita Llamas
   * Boton que toma lo del formulario y lo envia al ws de enviar correo
   */
  onSubmit(id: string) {
    this.answers = new Answer('', '', {});
    this.answers.unique_id = this.data.owner.id;
    this.answers.email = this.data.owner.email;
    this.answers.answers = this.form.value;
    this._contentService.sendEmail(this.answers).subscribe(result => {
      console.log('enviado');
      this.modalService.close(id);
      this.modalService.open('contact-succes');
    }, err => {
      if (err.status === 404) {
        console.log('404');
      } else {
        console.log('505');
      }
    });
  }

  /**@author Lupita Llamas
   * Open the contact modal
   */
  openModal(id: string) {
    this.modalService.open(id);
  }

  /**@author Lupita Llamas
   * Close the contact modal
   * @param {string} id
   */
  closeModal(id: string) {
    this.modalService.close(id);
  }

  /**author Lupita Llamas
   *
   * @param index
   */
  addSrcSlider(index) {

    this.imageIndex =  index;
    this.disp = 'block';
     this.backgroundc = 'rgba(0, 0, 0, 0.9)';
  }

  /**@author Lupita Llamas
  * previo de imagen para la galeria
  */
  onSwipeLeft() {
    if (this.imageIndex > 0) {
      this.imageIndex = this.imageIndex - 1;
    } else {
      this.imageIndex = this.images.length - 1;
    }
  }

  /**@author Lupita Llamas
   * siguiente de imagen para la galeria
   */
  onSwipeRight() {
    if (this.imageIndex < this.images.length - 1 ) {
      this.imageIndex = this.imageIndex + 1;
    } else {
      this.imageIndex = 0;
    }
  }
  /**@author Lupita Llamas
   * previo de imagen para la galeria
   */
  prevImage() {
    if (this.imageIndex > 0) {
      this.imageIndex = this.imageIndex - 1;
    } else {
      this.imageIndex = this.images.length - 1;
    }
  }

  /**@author Lupita Llamas
   * siguiente de imagen para la galeria
   */
  nextImage() {
    if (this.imageIndex < this.images.length - 1 ) {
      this.imageIndex = this.imageIndex + 1;
    } else {
      this.imageIndex = 0;
    }
  }

  /**@author Lupita Llamas
   * ultima de imagen para la galeria
   */
  lastImage() {
    this.imageIndex = this.images.length - 1;
  }

  /**@author Lupita Llamas
   * primera de imagen para la galeria
   */
  firstImage() {
    this.imageIndex = 0;
  }

  /**@author Lupita Llamas
   * Envia los clics de botones
   */
  public setClick(unique) {
    const indicator = new Indicator( unique, 1, 0);
    this._contentService.sendStats(indicator).subscribe(result => {
      console.log('sended');
    }, err => {
      console.log('error' + err.status);
    });
  }

  /**@author Lupita Llamas
  * Ng init inicializa el form control para el contacto
  */
  ngOnInit() {
    this.form = new FormGroup({
      firstName: new FormControl()
    });
  }

  /**@author Lupita Llamas
   * Hover de iconos de redes sociales
   * @param anchor_id - ID del selector
   */
  changeToRed(anchor_id) {
    const anchor = '#' + anchor_id;
    $(anchor).css('color', '#f00');
  }

  /**@author Lupita Llama
   * des Hover de iconos de redes sociales
   * @param anchor_id - Id del selector
   */
  changeToColor(anchor_id) {
    const anchor = '#' + anchor_id;
    $(anchor).css('color', this.data.card.text_color);
  }

  /********************************************************
   **** DE AQUí PARA ABAJO ES DE HUBER Y NO SE QUE HAGA ****
   ********************************************************/

  /**Huber
   * No se que haga esto
   */
  closeModalSlider() {
    this.disp = 'none';
  }

  /**Huber
   * añade algo a la vista
   */
  addSrcMessage(Src) {
    this.urlMessage = Src;
  }

  /**Huber
   * añade algo a la vista
   */
  addSrcPhone(Src) {
    this.urlPhone = Src;
  }

  /**Huber
   * añade algo a la vista
   */
  addSrcTv(Src) {
    this.urlTv = Src;
  }

  /**Huber
   * añade algo a la vista
   */
  addSrcFace(Src) {
    this.urlFace = Src;
  }

  /**Huber
   * añade algo a la vista
   */
  addSrcTwit(Src) {
    this.urlTwit = Src;
  }

  /**Huber
   * añade algo a la vista
   */
  addSrcInst(Src) {
    this.urlInst = Src;
  }

  openModalSlider(id: string, src: string) {
    this.srcSlider = src;
    this.modalService.open(id);
  }

  getBackground(image) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${image})`);
  }


}



// WEBPACK FOOTER //
// ./src/app/components/content/content.component.ts